import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils/checkPolotnoType';
import { Presenter } from '@d-id/types';
import { ElementType, GroupElementType } from 'polotno/model/group-model';
import { ImageElementType } from 'polotno/model/image-model';

export function getAvatarGroupFromPage(page: Page | undefined): GroupElementType | undefined {
    if (!page) {
        return undefined;
    }

    return page.children.find(
        child => child.type === 'group' && child.children.some((child: ElementType) => checkPolotnoType(child, polotnoTypes.Avatar))
    ) as GroupElementType | undefined;
}

export function getAvatarElementFromPage(page: Page | undefined): ImageElementType | undefined {
    if (!page) {
        return undefined;
    }

    // Check direct children for Avatar
    const directAvatar = page.children.find(child => checkPolotnoType(child, polotnoTypes.Avatar)) as ImageElementType | undefined;

    if (directAvatar) {
        return directAvatar;
    }

    // Check children of group elements for Avatar
    const groupAvatar = getAvatarGroupFromPage(page);

    if (groupAvatar) {
        return groupAvatar.children.find((child: ElementType) => checkPolotnoType(child, polotnoTypes.Avatar)) as
            | ImageElementType
            | undefined;
    }

    return undefined;
}

export function getAvatarPresenterFromPage(page: Page | undefined): Presenter | undefined {
    if (!page) {
        return undefined;
    }

    return getAvatarElementFromPage(page)?.custom?.presenter as Presenter | undefined;
}
